import logoSvg from "../assets/parpics-logo-temp.svg";

export const LOGO_SVG_PATH = logoSvg;
export const LOGO_ALT = "Parpics Logo";

export const CLIENT_PAID = "paid";
export const CLIENT_UNPAID = "unpaid";
